export enum CHANNEL_NAMES {
  AUTH_CHANNEL = "AUTH_CHANNEL",
}

export enum CHANNEL_MESSAGE_TYPES {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
}

export const retrieveAuthChannel = () => {
  const authChannel = new BroadcastChannel(CHANNEL_NAMES.AUTH_CHANNEL);
  return {
    authChannel,
    sendAuthChannelMessage: (msg: CHANNEL_MESSAGE_TYPES) => {
      authChannel.postMessage(msg);
    },
  };
};
